import type { ComponentType } from "react";
import { lazyRetry } from "@/lib/lazyRetry";

/**
 * The homepage is code-split for every route except SSR-owned country roots.
 * Those documents register the already-loaded module before rendering or
 * hydrating, so the first render is synchronous and matches the server HTML
 * (a suspended lazy boundary would otherwise discard the server markup).
 */
const LazyHomePage = lazyRetry(() => import("@/pages/HomePage"));
let eagerHomePage: ComponentType | null = null;

export function setEagerHomePage(component: ComponentType): void {
  eagerHomePage = component;
}

export function HomeRoute() {
  const Eager = eagerHomePage;
  return Eager ? <Eager /> : <LazyHomePage />;
}
